<template>
    <div class="container">
        <Row>
            <Col>

                <label v-if="label" for="documents">{{label}}</label>

                <div class="dropbox" :class="{focussed: isInputFocussed}">
                    <input class="input-file"
                           id="documents"
                           name="documents"
                           type="file"
                           accept="*/*"
                           @change="onFilesChange($event.target.name, $event.target.files)"
                           @focusin="isInputFocussed = true"
                           @focusout="isInputFocussed = false"
                           multiple
                    >
                    <p>Drag your file(s) here to begin
                        <br>
                        or click to browse
                    </p>
                </div>

            </Col>
        </Row>
        <Row v-if="value.length > 0">
            <Col class="col-12">
                <table class="table">
                    <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Name</th>
                        <th scope="col">Size</th>
                        <th scope="col">Status</th>
                        <th scope="col">Remove</th>
                    </tr>
                    </thead>
                    <tbody>
                    <FileUploadItem v-for="(file, idx) in value" :key="file.name"
                                    :idx="idx"
                                    :file="value[idx].file"
                                    :name="value[idx].name"
                                    @input="(val) => updateValue(val, idx)"
                                    @delete-file="(i) => removeFile(i)"
                                    :allowed-extensions="allowedExtensions"
                                    :max-size="maxSize"
                    ></FileUploadItem>
                    </tbody>
                </table>
            </Col>
        </Row>
    </div>
</template>

<script>
    import FileUploadItem from '../input/FileUploadItem'
    import Row from '../layout/Row'
    import Col from '../layout/Col'

    export default {
        name: 'FileUpload',
        props: {
            label: {
                type: String
            },
            value: {
                type: Array,
                default: []
            },
            rules: {
                type: String,
                default: ''
            },
            maxSize: {
                type: Number,
                default: 2097152 //2mb
            },
            allowedExtensions: {
                type: Array,
                default: []
            }
        },
        $_veeValidate: {
            name() {
                return this.label;
            },
            value() {
                return this.value;
            }
        },
        data() {
            return {
                isInputFocussed: false
            }
        },
        components: {
            FileUploadItem,
            Row,
            Col
        },
        methods: {
            async addFile(field, file) {
                if (!file) return;
                this.value.push({name: file.name, file: file});
            },
            onFilesChange(field, files) {
                return files.forEach(file => this.addFile(field, file));
            },
            updateValue: function (file, idx) {
                this.value[idx] = file;
                this.$emit('input', this.value);
            },
            removeFile: function (idx) {
                const newValue = this.value.slice(0, idx).concat(this.value.slice(idx + 1, this.value.length))
                this.$emit('input', newValue);
            }
        }
    }

</script>

<style lang="scss" scoped>

    .focussed {
        border-radius: 0.25em;
        border: 3px solid lightblue;
    }

    .dropbox {
        outline: 2px dashed grey;
        outline-offset: -10px;
        color: dimgray;
        padding: 10px 10px;
        min-height: 200px;
        position: relative;
        cursor: pointer;
        margin-bottom: 1em;
    }

    .input-file {
        opacity: 0;
        width: 100%;
        height: 200px;
        position: absolute;
        cursor: pointer;
    }

    .dropbox:hover {
        background: lightblue;
    }

    .dropbox p {
        font-size: 1.2em;
        text-align: center;
        padding: 50px 0;
    }
</style>
